import {useRouter} from 'next/router';
import {useGetStockQuery} from 'modules/stock-x/services';
import {APP_ROUTES_TO_URL} from 'core/modules/routing/constants';

const STOCK_DETAIL_PATHNAME = `${APP_ROUTES_TO_URL.stock}/[...slug]`;

export const useStockExtraLinksHidden = (): boolean => {
    const {pathname, query} = useRouter();
    const isStockDetailPage = pathname === STOCK_DETAIL_PATHNAME;
    const stockCode = isStockDetailPage ? (query.slug as string[] | undefined)?.[0] : undefined;

    const {data} = useGetStockQuery(stockCode as string, {skip: !stockCode});

    return Boolean(data?.menuIsHidden);
};
